module.exports = __webpack_public_path__ + "61ac9a09d717c6899190b1563a624593.svg";